import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { NotificationType } from '@app/shared/interfaces';
import { ToastNotificationsService } from '@app/shared/services/toast-notifications/toast-notifications.service';

@Component({
  standalone: false,
  selector: 'sbnb-forgot-pw-form',
  templateUrl: './forgot-pw-form.component.html',
  styleUrls: ['./forgot-pw-form.component.scss'],
})
export class ForgotPwFormComponent implements OnInit {
  public loading: boolean;

  public forgotPwForm: UntypedFormGroup;
  success: boolean;

  constructor(
    private fb: UntypedFormBuilder,
    private authService: AuthenticationService,
    private toast: ToastNotificationsService
  ) {}

  ngOnInit() {
    this.forgotPwForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  sendPasswordReminder(email: string) {
    this.loading = true;

    this.authService.passwordReset(email).subscribe((res: any) => {
      if (res.error) {
        this.toast.open(`${res.error.error}`, 'Dismiss', NotificationType.Error);
      } else {
        this.success = true;
      }

      this.loading = false;
    });
  }
}
